import {
  PrimaryNavIdentifier,
  NavLinkType,
} from '@zola-helpers/client/dist/es/constants/navConstants';
import { isUserPostWedding } from '@zola-helpers/client/dist/es/util/dateUtils';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import experimentFlags, { SHOP_HOLIDAYS_2022 } from 'util/experimentFlags';
import giftNavIcon from 'assets/images/navigation/gift.svg';
import type { MenuMenuSectionItem, MegaMenuNavItem } from './types';

const categoryChildren: MenuMenuSectionItem[] = [
  {
    title: 'Kitchen',
    path: '/shop/category/kitchen',
  },
  {
    title: 'Tabletop',
    path: '/shop/category/dining',
  },
  {
    title: 'Bed & Bath',
    path: '/shop/category/bedding-and-bath',
  },
  {
    title: 'Furniture',
    path: '/shop/category/furniture',
  },
  {
    title: 'Home',
    path: '/shop/category/home',
  },
  {
    title: 'Weekend',
    path: '/shop/category/weekend',
  },
  {
    title: 'Experiences',
    path: '/shop/category/experiences',
  },
  {
    title: 'Cash Funds',
    path: '/shop/honeymoon-cash-funds',
  },
  {
    title: 'Add From Anywhere',
    path: '/wedding-registry/add-from-other-stores',
  },
];

const exploreChildren = [
  {
    title: "Find a Couple's Registry",
    path: '/search/wedding-registry',
  },
  {
    title: 'About Zola Registry',
    path: '/wedding-registry',
  },
  {
    title: 'How Cash Gifts Work',
    path: '/wedding-registry/how-cash-gifts-work',
  },
  {
    title: 'Registries We Love',
    path: '/shop/registries-we-love',
  },
  {
    title: 'Registry Expert Advice',
    path: '/expert-advice/topic/registry',
  },
  {
    title: 'Registry FAQs',
    path: '/faq/category/115000342372-registry',
  },
];

const getNavData = ({
  id,
  onboardPath,
  registryPath,
  userContext,
}: {
  id: PrimaryNavIdentifier;
  onboardPath: string;
  registryPath: string;
  userContext: UserContext | undefined;
}): MegaMenuNavItem => {
  const featuredChildren = [
    {
      title: 'New Arrivals',
      path: '/shop/collection/new-arrivals',
    },
    {
      title: 'Collections',
      path: '/shop/gift-collections/starter-collections',
      icon: experimentFlags.getFlag(SHOP_HOLIDAYS_2022, userContext) ? giftNavIcon : undefined,
    },
    {
      title: 'Brands',
      path: '/shop/brands',
    },
    {
      title: 'Partner Stores',
      path: '/shop/brands',
    },
  ];

  const registryShopLink = isUserPostWedding(userContext)
    ? {
        title: 'Shop',
        path: '/registry/shop',
      }
    : {
        title: 'Add Gifts',
        path: '/registry/add-gifts',
      };
  const userActionsLinks: NavLinkType[] = [
    {
      title: 'Manage Registry',
      path: '/my-registry',
    },
    registryShopLink,
    {
      title: 'Registry Checklist',
      path: '/registry/checklist',
    },
    {
      title: 'Gift Tracker',
      path: '/registry/gift-tracker/your-gifts',
    },
    {
      title: 'Perks',
      path: '/wedding-registry/perks',
    },
  ];

  return {
    title: 'Registry',
    id,
    path: registryPath,
    parent: 'Registry',
    callToAction: {
      path: onboardPath,
      title: 'Build Your Registry',
      items: [
        'Gifts, experiences, and honeymoon funds',
        'Smart tools that simplify every step for you',
        "Support you won't find anywhere else",
      ],
    },
    userActionsLinks,
    children: [
      {
        headline: 'Featured',
        children: featuredChildren,
      },
      {
        headline: 'Shop By Category',
        children: categoryChildren,
      },
      {
        headline: 'Explore Zola Registry',
        borderLeft: true,
        children: exploreChildren,
      },
    ],
  };
};

export default getNavData;
